import { CreditViewResult, getCreditMemos, GetShareCreditMemoParameter, shareCreditMemoViaEmail, ShareCreditResult } from "@dana/Services/CreditService";
import { CreditStateActions } from "@dana/Store/Data/ViewCredit/Reducers/ViewCreditReducer";
import { ApiHandlerDiscreteParameter, createHandlerChainRunner, HasOnSuccess, markSkipOnCompleteIfOnSuccessIsSet } from "@insite/client-framework/HandlerCreator";
import { HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { DispatchProp } from "react-redux";


export interface ShareCreditMemoParameter extends HasPagingParameters {
    shareEmails?: string[];
    creditMemoNumber: string;
}
type Parameter = {
    onError?: (error: string) => void;
} & ShareCreditMemoParameter &
    HasOnSuccess<ShareCreditResult>;

type HandlerType = ApiHandlerDiscreteParameter<
    Parameter,
    GetShareCreditMemoParameter,
    ShareCreditResult,
    DispatchProp<CreditStateActions>
>;

export const DispatchSetParameters: HandlerType = props => {
    props.dispatch({
        type: "CreditViewState/IsLoading",
        isLoading: true,
    });
};
export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.apiParameter,
        ...props.parameter
    };
};

export const RequestDataFromApi: HandlerType = async props => {

    props.apiResult = await shareCreditMemoViaEmail(props.apiParameter);
};
export const ShareCreditMemoResponse: HandlerType = props => {
    if (props.apiResult) {
        props.dispatch({
            type: "CreditViewState/IsLoading",
            isLoading: false,
        });
    }
};
export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};


export const chain = [DispatchSetParameters, PopulateApiParameter, RequestDataFromApi, ShareCreditMemoResponse,ExecuteOnSuccessCallback];

const sareCreditMomo = createHandlerChainRunner(chain, "SareCreditMomo");
export default sareCreditMomo;